import { render, staticRenderFns } from "./ApplicantTestSelector.vue?vue&type=template&id=2bd4e2c8&scoped=true&"
import script from "./ApplicantTestSelector.vue?vue&type=script&lang=js&"
export * from "./ApplicantTestSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bd4e2c8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
installComponents(component, {VChip,VDataTable,VTab,VTabItem,VTabs,VTabsItems})


/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bd4e2c8')) {
      api.createRecord('2bd4e2c8', component.options)
    } else {
      api.reload('2bd4e2c8', component.options)
    }
    module.hot.accept("./ApplicantTestSelector.vue?vue&type=template&id=2bd4e2c8&scoped=true&", function () {
      api.rerender('2bd4e2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/application/components/Apply/ApplicantTestSelector.vue"
export default component.exports